module.exports = __webpack_public_path__ + "img/logo.6db13b10.png";